var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgGraduation = function SvgGraduation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 427.064,
    viewBox: "0 0 512 427.064",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mortarboard_1_",
    "data-name": "mortarboard (1)",
    d: "M502.024,156.633a15,15,0,0,0-.033-28.278l-241-85.031a14.992,14.992,0,0,0-9.981,0l-241,85.031a15,15,0,0,0-.034,28.278l95.469,33.94V288.42c0,16.149,16.847,29.806,50.073,40.59,28.961,9.4,64.647,14.577,100.483,14.577s71.521-5.177,100.483-14.577c33.226-10.784,50.073-24.44,50.073-40.59V190.573l39.417-14.013V312.144a45.115,45.115,0,0,0,0,85.1v57.285a15,15,0,0,0,30,0V397.248a45.115,45.115,0,0,0,0-85.1V165.894ZM460.973,369.82A15.125,15.125,0,1,1,476.1,354.7,15.142,15.142,0,0,1,460.973,369.82ZM256,73.375l196.069,69.179L256,212.257l-196.069-69.7ZM376.556,286.159c-2.875,2.9-13.167,9.839-36.4,16.466-24.781,7.069-54.67,10.962-84.16,10.962s-59.378-3.893-84.16-10.962c-23.229-6.627-33.521-13.567-36.4-16.466V201.238L250.975,242.31a14.99,14.99,0,0,0,10.048,0l115.531-41.072v84.921Z",
    transform: "translate(0 -42.469)"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgGraduation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Graduation.c3ecdf7aeab85356bb6592fbbbdf6e77.svg";